export default __webpack_public_path__ + "static/media/i3.eb38da95.png";